import { isEqual } from "lodash";

export { isEqual as areObjectsEqual };
